/* eslint-disable */

$('#export').on('click', () => {
    const profileTable = $('#profilesIndex')

    if (!profileTable || profileTable.length === 0) {
        return
    }

    const ids = $('#profilesIndex')
        .DataTable()
        .rows()
        .data()
        .map(r => r.id);

    $("profileIds").val(ids.join(','));

    const urlExport = linksoft.url.exportProfiles({ ids: ids.join(','), connectionId: $.connection.hub.id })

    $.ajax({
        url: urlExport,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: response => {
            console.log(response)
        },
        error: error => {
            console.log(error)
        }
    })
})


$('#export-with-filter').on('click', () => {
    const profileTable = $('#profilesIndex')

    if (!profileTable || profileTable.length === 0) {
        return
    }

    const ids = $('#profilesIndex')
        .DataTable()
        .rows()
        .data()
        .map(r => r.id);

    $("profileIds").val(ids.join(','));

    const url = linksoft.url.axesTypes({ ids: ids.join(',') });
    window.location.href = url;
})




// WEBPACK FOOTER //
// ./App/containers/profiles-export.js